module.exports = __webpack_public_path__ + "images/earnPointCard3_ca434fa.svg";